import { Outlet } from 'react-router-dom'
import Header from './Header'
import ApiKeyBanner from './ApiKeyBanner'
import { usePromoCodeFromUrl } from '../../hooks/usePromoCodeFromUrl'

export default function Layout() {
  // Auto-apply promo code from URL parameter (?promo_code=XXXXX)
  usePromoCodeFromUrl()

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <ApiKeyBanner />
      <main>
        <Outlet />
      </main>
    </div>
  )
}
